<mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
  <mat-expansion-panel-header>
    <mat-panel-title> Import File </mat-panel-title>
    <mat-panel-description> {{ func.name }}</mat-panel-description>
  </mat-expansion-panel-header>
  <div class="file-container">
    <mat-form-field class="toto2" appearance="fill" fxFlex>
      <mat-label>test File</mat-label>
      <input
        id="inputFileCSV"
        matInput
        placeholder="Select a file to upload"
        [value]="selectedSimpleFileInput !== undefined && selectedSimpleFileInput !== null ? selectedSimpleFileInput.item(0).name : ''"
        (click)="fileImportInput.click()"
      />
      <input
        hidden
        (change)="selectSimpleFileInput($event)"
        #fileImportInput
        type="file"
        id="fileImportInput"
        accept=".csv"
        accept-charset="UTF-8"
      />
      <mat-hint>File type : csv</mat-hint>
      <button mat-raised-button color="primary" matSuffix (click)="fileImportInput.click()">Choose file</button>
    </mat-form-field>
    <div class="btn-container">
      <button (click)="onSend()" mat-flat-button>Send <span class="material-icons"> send </span></button>
    </div>
  </div>
  @if (displayStatistiqueF2) {
  <mic-progress-bar color="accent" mode="indeterminate" ariaLabel="In Progress"></mic-progress-bar>
  } @if (importFileCsvStatus !== undefined && importFileCsvStatus !== null) {
  <h5 class="title-historique">Last use</h5>
  <div>
    <div class="historique">
      <div class="historique-body">
        <span matTooltip="userName" [matTooltipPosition]="'above'" class="material-icons"> person </span>
        <p>{{ importFileCsvStatus.userName }}</p>
      </div>
      <div class="historique-body">
        <span matTooltip="StartDate" [matTooltipPosition]="'above'" class="material-icons"> hourglass_top </span>
        <p>{{ importFileCsvStatus.startDate }}</p>
      </div>
      <div class="historique-body">
        <span matTooltip="EndDate" [matTooltipPosition]="'above'" class="material-icons"> hourglass_bottom </span>
        <p>{{ importFileCsvStatus.updateDate }}</p>
      </div>
      <div class="historique-body">
        <mic-icon icon="monitoring"></mic-icon>
        @if (importFileCsvStatus.status === 'OK' || importFileCsvStatus.status === 'KO') {
        <mat-icon [class]="importFileCsvStatus.status">{{ utilService.getTableRowStatusIcon(importFileCsvStatus.status) }}</mat-icon>
        } @else {
        <mic-spinner class="test" color="primary" [strokeWidth]="5"></mic-spinner>
        }
      </div>
      <a (click)="uploadCsvFile()" class="file_download"><mic-icon icon="file_download"></mic-icon></a>
    </div>
    <div class="progress-bar">
      @if (displayStatistique) {
      <div>STEP : {{ importFileCsvStatus.status === 'onInsert' ? 'Insertion' : 'Verification' }}</div>
      <mic-progress-bar color="accent" mode="determinate" [value]="(importFileCsvStatus.progress / progressBar) * 100"></mic-progress-bar>
      {{ (importFileCsvStatus.progress / progressBar) * 100 }}%
      <button mat-flat-button (click)="onStopTheTreatment()">Stop</button>
      }
    </div>
    @if (importFileCsvStatus.errorList.length !== 0) { @for (error of importFileCsvStatus.errorList; track $index) {
    <ul>
      <li>
        <span class="warning"><mic-icon icon="warning"></mic-icon></span>The error is in the column {{ error.columnNumber }} in the line
        {{ error.line }}. {{ error.message }}
      </li>
    </ul>
    } @if (func.secondFunction) {
    <div class="csvFileError">
      <p>Click here to download the CSV file containing the errors</p>
      <button mat-flat-button (click)="uploadCsvFileError()"><mic-icon icon="file_download"></mic-icon></button>
    </div>
    } }
  </div>
  <div>
    <mic-icon style="cursor: pointer; float: left" (click)="onHistoric()" icon="history"></mic-icon>
  </div>
  }
  <div>
    @if (this.user['role'] === 'Admin') {
    <mic-icon style="cursor: pointer; float: right" (click)="openUpdatedCsvFunction()" icon="settings"></mic-icon>
    }
  </div>
</mat-expansion-panel>
